import React, { useState } from 'react';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { app, API_BASE_URL } from '../../firebase/firebaseConfig';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Shield, KeyRound, AlertTriangle } from 'lucide-react';

function VerifyCode({ email, onVerificationSuccess }) {
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Send email and code to backend
    try {
      const response = await fetch(
        `${API_BASE_URL}/admin/verify`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, code }),
        }
      );
      console.log('here');
      console.log(response);
      const data = await response.json();
      console.log(data);
      if (data.success) {
        // Sign in with custom token
        const auth = getAuth(app);
        await signInWithCustomToken(auth, data.token);
        onVerificationSuccess();
      } else {
        setMessage(data.error || 'Verification failed. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="flex items-center justify-center gap-2 text-2xl">
            <Shield className="w-6 h-6" />
            Verify Your Identity
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium mb-2 block">Email address</label>
              <Input
                type="email"
                value={email}
                disabled
                className="bg-muted"
              />
            </div>
            <div>
              <label className="text-sm font-medium mb-2 block">Verification Code</label>
              <p className="text-xs text-muted-foreground mb-2">Check your email for the verification code</p>
              <Input
                type="text"
                placeholder="Enter verification code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="w-full flex items-center justify-center gap-2">
              <KeyRound className="w-4 h-4" />
              Verify
            </Button>
          </form>
          {message && (
            <div className="mt-4 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
              <div className="flex items-center gap-2 text-destructive">
                <AlertTriangle className="w-4 h-4" />
                <span className="text-sm font-medium">{message}</span>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default VerifyCode;
